import PropTypes from 'prop-types';
import css from './Hero.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var Hero = function Hero(_ref) {
  var title = _ref.title,
      subtitle = _ref.subtitle;
  return /*#__PURE__*/_jsxs("div", {
    className: css.root,
    children: [/*#__PURE__*/_jsx("h1", {
      className: css.title,
      children: title
    }), /*#__PURE__*/_jsx("h2", {
      className: css.subtitle,
      children: subtitle
    })]
  });
};

Hero.propTypes = {
  subtitle: PropTypes.string,
  title: PropTypes.string
};
export default Hero;